export const ENV = {
  DASHBOARD_URL: process.env.REACT_APP_DASHBOARD_URL,
  API_URL: process.env.REACT_APP_API_URL,
  PAYSTACK_PUBLIC_TEST: "pk_test_1541a5869b8806ae73085d015db8da1ea00d3709",
  IP_INFO_TOKEN: "98136ad30e4209",
};
